import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['commentRow', 'commentInput'];
  static values = { url: String };

  reveal(event) {
    const select = event.currentTarget.closest('td').querySelector('select');
    if (select) {
      select.classList.toggle('hide');
    }
  }

  save(event) {
    const select = event.currentTarget;
    this.patch({ kind: select.dataset.kind, [select.dataset.field]: select.value });
  }

  resetOverride(event) {
    this.patch({ kind: event.currentTarget.dataset.kind, reset: true });
  }

  toggleComment() {
    this.commentRowTarget.classList.toggle('hide');
  }

  saveComment() {
    this.patch({ kind: 'comment', comment: this.commentInputTarget.value });
  }

  clearComment() {
    this.patch({ kind: 'comment', reset: true });
  }

  async patch(fields) {
    const formData = new FormData();
    Object.entries(fields).forEach(([key, value]) => formData.append(`entry[${key}]`, value));

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': this.getCsrfToken(),
          Accept: 'application/json',
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.success) {
        this.element.outerHTML = data.state_html;
        if (data.message && typeof toastr !== 'undefined') {
          toastr.success(data.message);
        }
      } else if (data.message && typeof toastr !== 'undefined') {
        toastr.error(data.message);
      }
    } catch (error) {
      if (typeof toastr !== 'undefined') {
        toastr.error('Wystąpił błąd podczas zapisywania. Spróbuj ponownie.');
      }
    }
  }

  getCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    return token ? token.getAttribute('content') : '';
  }
}
